import type { ReactNode } from 'react'
import { Icon, IconNameEnum } from '@/React/Shared/Component/Icon'

interface MicrosoftSocialAuthButtonProps {
    url: string
    useBookingFormThemeCssVariables?: boolean
    children?: ReactNode
    className?: string
}

export function MicrosoftSocialAuthButton({
    url,
    useBookingFormThemeCssVariables = false,
    children = 'Sign in with Microsoft',
    className = '',
}: MicrosoftSocialAuthButtonProps) {
    const focusRingClass = useBookingFormThemeCssVariables
        ? 'focus:ring-booking-form-theme-main-background-color'
        : 'focus:ring-primary'

    return (
        <a
            href={url}
            className={`flex items-center justify-center gap-3 rounded-lg2 bg-white px-3 py-2.5 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-stone-200 hover:bg-gray-50 focus:outline-none focus:ring-2 ${focusRingClass} ${className}`.trim()}
        >
            <Icon
                name={IconNameEnum.Microsoft}
                className="h-7 w-7 shrink-0"
                aria-hidden="true"
            />
            <span className="text-sm font-semibold leading-6">{children}</span>
        </a>
    )
}
